
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Login from '../views/Login/Login';
import ForgotPassword from '../views/ForgotPassword/forgotPassword';
import SignUp from '../views/SignUp/SignUp';
import ResetPassword from '../views/ResetPassword/ResetPassword';
// import Home from '../views/Home/Home';
import EmailVerified from '../views/EmailVerified/EmailVerified';
// import SideBar from '../components/SideBar/SideBar';
import SignUpSuccess from '../views/SignUpSuccess/SignUpSuccess';
import UserContainer from '../views/Settings/User/User';
import EmailProviderContainer from '../views/Settings/EmailProvider/EmailProvider';
import SmtpContainer from '../views/Settings/EmailProvider/Smtp';
import GoogleEmailContainer from '../views/Settings/EmailProvider/GoogleEmail';
import TextProviderContainer from '../views/Settings/TextProvider/TextProvider';
import TwilioContainer from '../views/Settings/TextProvider/Twilio';
import EmailSignatureContainer from '../views/Settings/EmailSignature/EmailSignature';
import GmailAuthRoute from './GmailAuthRoute';
import PrivateRoute from './PrivateRoute';
import TwilioAuthRoute from './TwilioAuthRoute';
import NotFound from '../components/NotFound';
import DashboardContainer from '../views/Dashboard/Dashboard';
import CreateCampaignContainer from '../views/Campaigns/CreateCampaign';
import CampaignDetailsContainer from 'views/Campaigns/CampaignDetails';
import AdminRoute from './AminRoute';
import CampaignSetupContainer from "views/Campaigns/CampaignSetup";
import CampaignScheduleContainer from "views/Campaigns/CampaignSchedule"; 
//eslint-disable-next-line
// import CampaignLeadsContainer from "../views/Campaigns/CampaignLeads";
import CampaignCsvContainer from "views/Campaigns/CampaignCsv";
import CampaignSuccessContainer from "views/Campaigns/CampaignSuccess";
import CampaignNameContainer from "../views/Campaigns/CampaignName";
import CampaignUploadLeadsContainer from '../views/Campaigns/CampaignUploadLeads';
import CampaignAutoScriptContainer from '../views/Campaigns/CampaignAutoScript';
import CampaignScriptOptionContainer from '../views/Campaigns/CampaignScriptOption';
import CampaignLeadListContainer from 'views/Campaigns/CampaignLeadList';


// Admin Routes
// import AdminDashboard from '../views/Admin/Dashboard/Dashboard';
import RolesContainer from '../views/Admin/Dashboard/Roles';
import PermissionContainer from '../views/Admin/Dashboard/Permissions';
import ModulesContainer from '../views/Admin/Dashboard/Modules';

const Routing = () => {
    return (
        <BrowserRouter>
            <Switch>
                <Route path='/' exact component={Login} />
                <Route path='/sign-up' exact component={SignUp} />
                <Route path='/forgot-password' exact component={ForgotPassword} />
                <Route path='/reset-password' exact component={ResetPassword} />
                <Route path='/email-verified' exact component={EmailVerified} />
                <Route path='/sign-up-success' exact component={SignUpSuccess} />
                {/* <Route path='/home' exact component={Home} /> */}
                <PrivateRoute path='/settings' exact component={UserContainer} />
                <PrivateRoute path='/settings/user' exact component={UserContainer} /> 
                <GmailAuthRoute exact path='/settings/email-provider' component={EmailProviderContainer} />
                <PrivateRoute path='/settings/email-provider/smtp' exact component={SmtpContainer} />
                <PrivateRoute path='/settings/email-provider/google-email' exact component={GoogleEmailContainer} />
                <TwilioAuthRoute path='/settings/text-provider' exact component={TextProviderContainer} />
                <PrivateRoute path='/settings/text-provider/twilio' exact component={TwilioContainer} />
                <PrivateRoute path='/settings/email-signature' exact component={EmailSignatureContainer} />
                <PrivateRoute path='/dashboard' exact component={DashboardContainer} />
                <PrivateRoute path='/create-campaign' excat component={CreateCampaignContainer} />
                <PrivateRoute path='/campaign-name' excat component={CampaignNameContainer} />
                <PrivateRoute path='/campaigns/campaign-details/:id?' component={CampaignDetailsContainer} />

                <PrivateRoute path="/campaigns/setup/:id?" component={CampaignSetupContainer} />
                <PrivateRoute path="/campaigns/schedule/:id?" component={CampaignScheduleContainer} />
                {/* <PrivateRoute path="/campaigns/leads/:id?" component={CampaignLeadsContainer} /> */}
                <PrivateRoute path="/campaigns/leads/:id?" component={CampaignLeadListContainer} />
                <PrivateRoute path="/campaigns/uploadleads/:id?" component={CampaignUploadLeadsContainer} />
                <PrivateRoute path="/campaignCsv/:id?" component={CampaignCsvContainer} />
                <PrivateRoute path="/campaignSuccess/:id?" component={CampaignSuccessContainer} />
                <PrivateRoute path="/campaignAutoscript/:id?" component={CampaignAutoScriptContainer} />
                <PrivateRoute path="/campaignOption/:id?" component={CampaignScriptOptionContainer} />

                <AdminRoute path='/admin-settings' exact component={RolesContainer} />
                <AdminRoute path='/admin-settings/roles' exact component={RolesContainer} />
                <AdminRoute path='/admin-settings/modules' exact component={ModulesContainer} />
                <AdminRoute path='/admin-settings/permissions' exact component={PermissionContainer} />
                
                <Route path="*" component={NotFound} />

            </Switch>
        </BrowserRouter>
    )
}

export default Routing
